module.exports = __webpack_public_path__ + "img/aboutUsTopImg.2225d726.svg";